import { createReducer, on } from '@ngrx/store';
import * as ShopActions from './shop.actions';

export interface ShopState {
  selectedShop: any | null;
  stores: any[];
  loading: boolean;
  error: string | null;
}

export const initialShopState: ShopState = {
  selectedShop: null,
  stores: [],
  loading: false,
  error: null,
};

export const shopReducer = createReducer(
  initialShopState,
  on(ShopActions.selectShop, (state, { shop }) => ({ ...state, selectedShop: shop })),
  on(ShopActions.clearShopState, () => ({ ...initialShopState })),
  on(ShopActions.getSelectedShop, (state) => ({ ...state })), // Get action doesn't change state
  on(ShopActions.getStoreList, (state) => ({ ...state, loading: true, error: null })),
  on(ShopActions.setStoreList, (state, { stores }) => ({ ...state, stores, loading: false, error: null })),
  on(ShopActions.updateStoreInList, (state, { updatedStore }) => ({
    ...state,
    stores: state.stores.map(store => 
      store.id === updatedStore.id ? { ...store, ...updatedStore } : store
    ),
    selectedShop: state.selectedShop?.id === updatedStore.id 
      ? { ...state.selectedShop, ...updatedStore } 
      : state.selectedShop
  })),
  on(ShopActions.addStoreToList, (state, { newStore }) => ({
    ...state,
    stores: [...state.stores, newStore]
  }))
);
